import { CHECKOUT_STEP_NAMES as STEP_NAMES, CHECKOUT_FLOW_NAMES as FLOW_NAMES } from '../constants';
import stepsContent from './stepsContent';

const CheckoutWithHomeAddress = {
    name: FLOW_NAMES.CHECKOUT_WITH_HOME_ADDRESS,
    steps: [
        stepsContent[STEP_NAMES.SHIPPING_ADDRESS],
        stepsContent[STEP_NAMES.HOME_ADDRESS],
        stepsContent[STEP_NAMES.PAYMENT_METHODS],
        stepsContent[STEP_NAMES.ORDER_SUMMARY],
        stepsContent[STEP_NAMES.ORDER_CONFIRMATION],
        stepsContent[STEP_NAMES.PHONE_VERIFICATION],
        stepsContent[STEP_NAMES.TWOFA_HELP],
        stepsContent[STEP_NAMES.ORDER_ERROR],
    ],
};

export default CheckoutWithHomeAddress;
